<section class="video-card" (click)="onVideoClick(video)">
  <app-video-thumbnail [video]="video"> </app-video-thumbnail>
  <app-video-metadata [video]="video">
    <p middle-content class="video-card-title">
      @if (isLoading()) {
      <span>
        <span class="skeleton"> Loading video title, please wait... </span>
      </span>
      } @else {
      <span class="text">{{ video.title }}</span>
      }
    </p>
  </app-video-metadata>
</section>
